import axios from 'axios';

const API_BASE_URL_SIGNS = `${process.env.REACT_APP_API_URL}/api/signs`;
const API_BASE_URL_DASHBOARD = `${process.env.REACT_APP_API_URL}/api/dashboard`;
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/drives`;

export const fetchSignsApi = async () => {
  const response = await axios.get(`${API_BASE_URL_SIGNS}/new`);
  return response;
};

export const fetchSignImagesApi = async (signCodes) => {
  const response = await axios.post(`${API_BASE_URL_SIGNS}/new/images`, {
    codes: signCodes,
  });
  return response;
};

export const fetchGPSApi = async (selectedDriveId) => {
  const response = await axios.get(
    `${API_BASE_URL_DASHBOARD}/getGPSData/?drive_id=${selectedDriveId}`
  );
  return response.data.data;
};

export const fetchEventsApi = async ({ driveId, cursor, signal, limit = 100 }) => {
  const response = await axios.get(
    `${API_BASE_URL}/${driveId}/events`,
    {
      params: {
        limit,
        cursor,
      },
    },
    { signal }
  );

  return response.data;
};

export const fetchSelectedEventImageUrlApi = async (eventId) => {
  const response = await axios.get(`${API_BASE_URL}/events/image-url/${eventId}`);

  return response;
};

export const deleteSignFromDriveApi = async (driveid, eventid) => {
  const response = await axios.post(`${API_BASE_URL}/remove-sign-from-drive`, {
    eventID: eventid,
    driveID: driveid,
  });
  return response;
};

export const changeSignApi = async (driveid, eventid, signName, signCode, signType) => {
  const response = await axios.put(`${API_BASE_URL}/events/change-sign`, {
    eventID: eventid,
    driveID: driveid,
    signName,
    signCode,
    signType,
  });
  return response;
};

export const repositionSignsApi = async (driveid, repositionedSigns) => {
  const response = await axios.put(`${API_BASE_URL}/events/reposition-signs`, {
    driveID: driveid,
    events: repositionedSigns,
  });
  return response;
};

export const editDriveNameApi = async (driveId, driveName) => {
  const response = await axios.post(`${API_BASE_URL}/edit-name`, {
    driveID: driveId,
    driveName: driveName,
  });
  return response;
};

export const getNearestGpsDataApi = async (driveId, timestamp) => {
  const response = await axios.post(`${API_BASE_URL_DASHBOARD}/nearest-record`, {
    drive_id: driveId,
    timestamp,
  });
  return response;
};

export const addNewSignApi = async (request) => {
  const response = await axios.post(`${API_BASE_URL_DASHBOARD}/add-new-event`, request);
  return response;
};
